var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tsos-home-header"},[_c('img',{staticClass:"top-logo",attrs:{"src":require("@/assets/tsos-widget/logo-full.png"),"alt":""}}),_c('h3',{staticStyle:{"margin-bottom":"0px","padding-bottom":"0px"}},[_vm._v(" What would you like help with today? ")])])
}]

export { render, staticRenderFns }